import React, { useState, useEffect } from "react";
import { Modal, Form, Input, DatePicker, Button, message, Divider, Row, Col, Switch } from "antd";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import moment from "moment";

export const BranchModalUpdate = ({ branch, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (branch) {
      form.setFieldsValue({
        Name: branch.name,
        Code: branch.code,
        Region: branch.region,
        Cluster: branch.cluster,
        Zone: branch.zone,
        OpeningDate: branch.openingDate ? moment(branch.openingDate) : null,
        ClosingDate: branch.closingDate ? moment(branch.closingDate) : null,
        IsActive: branch.isActive ?? true,
      });
    }
  }, [branch, form]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = {
        Id: branch.id,
        Name: values.Name?.trim(),
        Code: values.Code?.trim() || null,
        AddressId: branch.addressId ?? null,
        Region: values.Region?.trim() || null,
        Cluster: values.Cluster?.trim() || null,
        Zone: values.Zone?.trim() || null,
        OpeningDate: values.OpeningDate ? values.OpeningDate.format("YYYY-MM-DD") : null,
        ClosingDate: values.ClosingDate ? values.ClosingDate.format("YYYY-MM-DD") : null,
        IsActive: values.IsActive ?? true,
      };

      const response = await axios.put(
        `${Api_Url}api/v1/Branch/${branch.id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        message.success("Branch updated successfully");
        onSuccess();
      }
    } catch (error) {
      message.error(error.response?.data?.message || "Failed to update branch");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <span style={{ fontSize: "18px", fontWeight: "bold" }}>Update Branch</span>
      }
      open={true}
      onCancel={onClose}
      footer={[
        <Button key="back" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Update Branch
        </Button>,
      ]}
      centered
      width={700}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="Name"
              label="Branch Name"
              rules={[
                { required: true, message: "Please enter branch name" },
                { max: 50, message: "Name must not exceed 50 characters" },
              ]}
            >
              <Input placeholder="e.g. Noida Sector 62" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="Code" label="Branch Code">
              <Input placeholder="e.g. RHF-NOI-01" />
            </Form.Item>
          </Col>
        </Row>

        <Divider plain>Hierarchy</Divider>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="Region" label="Region">
              <Input placeholder="e.g. North" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="Cluster" label="Cluster">
              <Input placeholder="e.g. Delhi NCR" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="Zone" label="Zone">
              <Input placeholder="e.g. Zone A" />
            </Form.Item>
          </Col>
        </Row>

        <Divider plain>Dates</Divider>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="OpeningDate" label="Opening Date">
              <DatePicker
                style={{ width: "100%" }}
                format="DD-MM-YYYY"
                placeholder="Select opening date"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="ClosingDate" label="Closing Date">
              <DatePicker
                style={{ width: "100%" }}
                format="DD-MM-YYYY"
                placeholder="Select closing date"
              />
            </Form.Item>
          </Col>
        </Row>

        <Divider plain>Status</Divider>

        <Form.Item
          name="IsActive"
          label="Active"
          valuePropName="checked"
          tooltip="Disable to deactivate this branch"
        >
          <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
